export const CONFIG = {
  RPS_GRID: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "row",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    searchPanel: {
      visible: true,
    },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    /*  paging: {
              pageSize: 10
          },
          pager: {
              showPageSizeSelector: true,
              allowedPageSizes: [5, 10, 20, 50],
              showInfo: true
          },
          */
    export: {
      enabled: true,
      fileName: "SPS_Rail",
    },
    editing: {
      mode: "batch",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    /*onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },

  RPS_EXPERIMENT: {
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
      enabled: true,
      allowSearch: true,
      mode: "select",
    },

    headerFilter: {
      visible: true,
    },
    sorting: {
      mode: "row",
    },
    grouping: {
      contextMenuEnabled: true,
    },
    // searchPanel: {
    //   visible: true,
    // },
    filterRow: {
      visible: true,
      applyFilter: "auto",
    },
    /*  paging: {
              pageSize: 10
          },
          pager: {
              showPageSizeSelector: true,
              allowedPageSizes: [5, 10, 20, 50],
              showInfo: true
          },
          */
    export: {
      enabled: true,
      fileName: "SPS_Experiment",
    },
    editing: {
      mode: "cell",
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      useIcons: true,
    },
    /*onRowPrepared: function (e) {
            if (e.rowType == 'data' && e.data.Role == 'Owner') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(191, 217, 156)');
            }
            else if (e.rowType == 'data' && e.data.Role == 'Alternate') {
                e.rowElement.find("td").css('backgroundColor', 'rgb(241, 226, 177)');
            }
            else {
                return false;
            }
        },
        */
    onToolbarPreparing: function (e) {
      var dataGrid = e.component;
      var toolbarItems = e.toolbarOptions.items;
      // Adds a new item
      toolbarItems.unshift(
        {
          location: "before",
          template: "",
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "refresh",
            hint: "Refresh",
            onClick: function () {
              dataGrid.refresh();
            },
          },
        }
      );
    },
  },
};
export const sizeValues = [
  "8pt",
  "10pt",
  "12pt",
  "14pt",
  "18pt",
  "24pt",
  "36pt",
];
export const fontValues = [
  "Arial",
  "Courier New",
  "Georgia",
  "Impact",
  "Lucida Console",
  "Tahoma",
  "Times New Roman",
  "Verdana",
];
export const headerValues = [false, 1, 2, 3, 4, 5];
